import React, { useEffect, useRef, useState } from "react";
import { Button, Input, message, Spin, Tabs } from "antd";

import AddPatient from "./addPatient/AddPatient";
import BoardColumnItem from "./BoardColumnItem";

import arrowLeftFill from "../../assets/icons/arrow-left-purple.svg";
import search from "../../assets/icons/search-normal-gray.svg";
import arrowLeft from "../../assets/icons/arrow-left.svg";
import reload from "../../assets/icons/refresh-p.svg";
import plus from "../../assets/icons/add-circle2.png";
import chart from "../../assets/icons/chart-2.svg";
import trash from "../../assets/icons/trash2.png";
import eye from "../../assets/icons/eye.svg";

import { patientInputFilterQuery } from "./utils";
import { controller } from "./controller";
import { isNotEmpty } from "../../utils";

export default function BoardColumnNormalView({
  setSelectedBoardStatistics,
  setClickedPatientId,
  setCollapsedBoards,
  setDetailedBoards,
  onDelete,
  board,
}) {
  const [addPatient, setAddPatient] = useState(false);
  const [activeTab, setActiveTab] = useState("processed");
  const [searchPatientInput, setSearchPatientInput] = useState("");
  const [patients, setPatients] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedPatientIds, setSelectedPatientIds] = useState([]); // Add this state
  const [processingPatientsNumber, setProcessingPatientsNumber] = useState(null)
  // const isFirstRender = useRef(true);

  const tabs = [
    {
      key: "processed",
      label: <TabLabel text="Processed" number={board.proccessed_patients_count} tabKey="processed" activeTab={activeTab} />,
      children: null,
    },
    {
      key: "processing",
      label: <TabLabel text="Processing" number={processingPatientsNumber} tabKey="processing" activeTab={activeTab} />,
      children: null,
    },
    { key: "failed", label: <TabLabel text="Failed" number={board.failed_patients_count} tabKey="failed" activeTab={activeTab} />, children: null },
  ];

  useEffect(() => {
    setPatients(board.patients);
  }, [board, board.patients]);

  // const displayPatients = patients || board.patients; // Fallback to prop if local state is null

  const getManualPatients = async () => {
    try {
      const response = await controller.manualBoardSearchPatient(board.id);
      setPatients(response.json);
    } catch (err) {
      message.error("Something went wrong while searching for patient");
      console.error(err);
    }
  };

  console.log("patients", patients)
  useEffect(() => {
    if (searchPatientInput) return;

    async function searchBoardPatient() {
      try {
        setLoading(true);
        if (board.type === "manual"){
          const response = await controller.manualBoardSearchPatient(board.id);
          isNotEmpty(response) && setPatients(response.json)
        }
        else if (board.type === "automated" && activeTab === "processed"){
          console.log("board", board)
          console.log("board.processed_patients", board.proccessed_patients)
          setPatients(board.proccessed_patients.patients)//response = await controller.manualBoardSearchPatient(board.proccessed_patients.id);
        }else if (board.type === "automated" && activeTab === "failed"){
          setPatients(board.failed_patients.patients) //response = await controller.manualBoardSearchPatient(board.failed_patients.id);
        }else { 
          getProcessingPatients() 
        }
      } catch (err) {
        message.error("Something went wrong while searching for patient");
        console.error(err);
      } finally {
        setLoading(false);
      }
    }
    searchBoardPatient();
  }, [searchPatientInput, activeTab]);

  useEffect(
    function () {
      if (!searchPatientInput) return;

      async function searchBoardPatient() {
        try {
          const queryParams = patientInputFilterQuery(searchPatientInput, board.type);
          // Check if we have valid query parameters
          if (queryParams.toString().length === 0) {
            console.log("No valid search criteria found");
            return;
          }
          let response;
          if (board.type === "manual") response = await controller.manualBoardSearchPatient(board.id, queryParams);
          else if (board.type === "automated" && activeTab === "processed")
            response = await controller.manualBoardSearchPatient(board.proccessed_patients.id, queryParams);
          else if (board.type === "automated" && activeTab === "failed")
            response = await controller.manualBoardSearchPatient(board.failed_patients.id, queryParams);
          else if (board.type === "automated" && activeTab === "processing")
            response = await controller.autoBoardSearchPatient(board.id, queryParams);

          setPatients(response.json);
        } catch (err) {
          message.error("Something went wrong while searching for patient");
          console.error(err);
        }
      }
      const timeoutId = setTimeout(() => searchBoardPatient(), 200);
      return () => clearTimeout(timeoutId);
    },
    [searchPatientInput, activeTab]
  );

  async function getProcessingPatients() {
    try {        
      const response = await controller.getProcessingPatients(board.id);
      if ( Array.isArray(response.json) ) {
        setPatients(response.json)
        setProcessingPatientsNumber(response.json.length)
      }
    } catch (err) {
      setPatients([])
      setProcessingPatientsNumber(0)
      message.error("Something went wrong while fetching Processing patient");
      console.error(err);
    }
  }
  useEffect(() => {
    if (activeTab !== "processing") return;
    getProcessingPatients();
  }, [activeTab]);

  const handleRemovePatient = async (patientId) => {
    let boardId;
    // Determine the correct board ID based on type and tab
    if (board.type === "manual") boardId = board.id;
    else if (board.type === "automated" && activeTab === "failed") boardId = board.failed_patients;
    else if (board.type === "automated" && activeTab === "processed") boardId = board.processed_patients;

    try {
      await controller.removePatient(boardId, patientId);
      // Remove the patient from local state to update UI immediately
      setPatients((prevPatients) => prevPatients.filter((patient) => patient.id !== patientId));

      message.success("Patient removed successfully");
    } catch (err) {
      message.error("Something went wrong while deleting patient");
      console.error(err);
    }
  };

  const handleSaveChanges = async () => {
    try {
      const response = await controller.addPatients(board.id, {
        patient_ids: selectedPatientIds,
      });
      // Handle success
      await getManualPatients();
      message.success("Patients added successfully");
      setAddPatient(false);
      setSelectedPatientIds([]); // Reset selection
    } catch (err) {
      message.error("Something went wrong while adding patients");
      console.error(err);
    }
  };

  const handlePatientSelection = (patientId, isSelected) => {
    setSelectedPatientIds((prev) => {
      if (isSelected) {
        return [...prev, patientId];
      } else {
        return prev.filter((id) => id !== patientId);
      }
    });
  };

  const handleAddNewPatient = async (patientId) => {
    try {
      const response = await controller.addPatients(board.id, {
        patient_ids: [patientId],
      });
      // Handle success
      await getManualPatients();
      message.success("Patients added successfully");
      setAddPatient(false);
      setSelectedPatientIds([]); // Reset selection
    } catch (err) {
      message.error("Something went wrong while adding patients");
      console.error(err);
    }
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          paddingTop: 20,
          paddingBottom: 20,
          marginInline: 25,
          borderBottom: "1px solid #C9C1F1",
          marginBottom: 20,
        }}
      >
        <p style={{ marginBottom: 0, fontSize: 16, fontWeight: 500 }}>{board.name}</p>

        {!addPatient ? (
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <span
              style={{
                backgroundColor: board.type === "automated" ? "#EEEDFA" : "#E0DDF7",
                color: "#6B43B5",
                padding: "3px 10px",
                borderRadius: 100,
                fontSize: 12,
                textTransform: "capitalize",
              }}
            >
              {board.type}
            </span>

            <div
              style={{ boxShadow: "0 0 10px 0 rgba(0,0,0,0.1)", padding: 3, borderRadius: 7 }}
              onClick={() => setCollapsedBoards((prevBoards) => [...prevBoards, board.id])}
            >
              <img src={arrowLeftFill} alt="right arrow" className="mouse-hover" />
            </div>
          </div>
        ) : (
          <Button style={{ color: "#6B43B5", border: "1px solid #6B43B5" }} onClick={() => setAddPatient(false)}>
            <img src={arrowLeft} alt="arrow-left" />
            Back
          </Button>
        )}
      </div>

      {!addPatient ? (
        <>
          <div style={{ paddingInline: 20 }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <Input
                type="text"
                style={{ borderRadius: 7, border: "1px solid #6B43B5" }}
                placeholder="Search Patient"
                value={searchPatientInput}
                onChange={(e) => setSearchPatientInput(e.target.value)}
              />
              <img src={search} alt="search icon" style={{ marginLeft: "-30px" }} />
            </div>

            {board.type === "manual" && board.real_manual && (
              <Button
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 5,
                  backgroundColor: "#E0DDF7",
                  color: "#6B43B5",
                  width: "100%",
                  borderRadius: 7,
                  marginTop: 10,
                  marginBottom: 20,
                }}
                onClick={() => setAddPatient(true)}
              >
                <img src={plus} alt="plus" />
                <span>Add Patient</span>
              </Button>
            )}

            {board.type === "automated" && (
              <Tabs items={tabs} defaultActiveKey="processed" onChange={(key) => setActiveTab(key)} style={{ marginTop: 10 }} />
            )}

            <div
              style={{ display: "flex", flexDirection: "column", gap: 10, overflowY: "auto", height: board.type === "manual" ? 444 : 435 }} // The height for manual boards is a little short. So it needs to be bigger.
              className="custom-scroll"
            >
              {loading && <Spin style={{ marginTop: 20 }} />}
              {!loading &&
                isNotEmpty(patients) &&
                patients.map((patient) => (
                  <BoardColumnItem
                    status={board.type === "manual" ? null : activeTab}
                    setClickedPatientId={setClickedPatientId}
                    onDelete={handleRemovePatient}
                    patientData={patient}
                    key={patient.id}
                  />
                ))}
            </div>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              height: 51,
              borderBottomLeftRadius: 8,
              borderBottomRightRadius: 8,
              backgroundColor: "white",
              padding: 15,
              boxShadow: "0 -6px 10px 0 rgba(0, 0, 0, 0.05)",
            }}
          >
            <p style={{ marginBottom: 0, fontSize: 14, fontWeight: 400 }}>Total</p>

            <span style={{ color: "#6B43B5" }}>
              {patients && board.type === "manual"
                ? patients.length
                : board.failed_patients_count + board.proccessed_patients_count + processingPatientsNumber}{" "}
              Patients
            </span>

            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <img
                src={trash}
                alt="reload"
                style={{ cursor: "pointer", width: 18, height: 18, color: "purple" }}
                onClick={() => onDelete(board.id)}
              />
              <img src={reload} alt="reload" style={{ cursor: "pointer", width: 18, height: 18, color: "purple" }} />
              {board.type !== "manual" && (
                <img src={eye} alt="eye" style={{ cursor: "pointer", width: 18, height: 18 }} onClick={() => setDetailedBoards(true)} />
              )}
              <img
                src={chart}
                alt="chart"
                style={{ cursor: "pointer", width: 18, height: 18, color: "purple" }}
                onClick={() => setSelectedBoardStatistics(board.id)}
              />
            </div>
          </div>
        </>
      ) : (
        <>
          <AddPatient
            setAddPatient={setAddPatient}
            boardId={board.id}
            onPatientSelection={handlePatientSelection}
            selectedPatientIds={selectedPatientIds}
            onAddNewPatient={handleAddNewPatient}
          />

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              height: "100%",
              borderBottomLeftRadius: 8,
              borderBottomRightRadius: 8,
              backgroundColor: "#EEEDFA",
              padding: "0px 20px",
              boxShadow: "0 -6px 10px 0 rgba(0, 0, 0, 0.05)",
            }}
          >
            <Button type="primary" style={{ width: "100%", margin: "20px 10px" }} onClick={handleSaveChanges}>
              Save Changes
            </Button>
          </div>
        </>
      )}
    </>
  );
}

function TabLabel({ text, number, tabKey, activeTab }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
      <span style={{ fontSize: 13, color: tabKey === activeTab ? "#6B43B5" : "#848696" }}>{text}</span>
      <span
        style={{
          borderRadius: 100,
          backgroundColor: tabKey === activeTab ? "#EEEDFA" : "rgba(151, 151, 151, 0.15)",
          color: tabKey === activeTab ? "#6B43B5" : "#848696",
          fontSize: 10,
          width: 20,
          height: 20,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {number}
      </span>
    </div>
  );
}
